/* ===== Hannitox · modo clienta vs modo asesora =====
   ?a=piel8183          -> modo asesora (queda guardado en ese dispositivo)
   #p=...&k=vip8183h    -> abre el protocolo (link que se entrega al comprar)
   Sin llave            -> la clienta solo ve su diagnostico + boton a WhatsApp
*/
(function(){
  var KEY_A='piel8183', KEY_P='vip8183h';

  function qs(n){var m=(location.search||'').match(new RegExp('[?&]'+n+'=([^&#]+)'));return m?decodeURIComponent(m[1]):'';}
  function hs(n){var m=(location.hash||'').match(new RegExp('[#&]'+n+'=([^&]+)'));return m?decodeURIComponent(m[1]):'';}

  var esAsesora=false;
  try{
    if(qs('a')==='salir'){localStorage.removeItem('hx_asesora');esAsesora=false;}
    else if(qs('a')===KEY_A){localStorage.setItem('hx_asesora','1');esAsesora=true;}
    else if(localStorage.getItem('hx_asesora')==='1'){esAsesora=true;}
  }catch(e){esAsesora=(qs('a')===KEY_A);}
  var abierto = esAsesora || (hs('k')===KEY_P);

  var css='.modo-clienta .deliver,.modo-clienta #scriptBox,.modo-clienta #prodPick,.modo-clienta .gear{display:none!important}'
   +'.hx-sealed{position:relative;border-radius:26px;overflow:hidden;border:1.5px solid var(--pink-soft);background:linear-gradient(160deg,#F4F0FB,#fff);box-shadow:var(--shadow);margin-top:16px}'
   +'.hx-peek{padding:22px 22px 0;filter:blur(3.5px);opacity:.5;pointer-events:none}'
   +'.hx-prow{display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid var(--line)}'
   +'.hx-pdot{width:26px;height:26px;border-radius:9px;background:var(--sage);flex:0 0 auto}'
   +'.hx-pline{height:10px;border-radius:99px;background:var(--blush-2);flex:1}'
   +'.hx-pline.s{max-width:52%}'
   +'.hx-fade{position:absolute;left:0;right:0;top:118px;height:90px;background:linear-gradient(180deg,rgba(255,255,255,0),#F8F5FD)}'
   +'.hx-body{position:relative;padding:6px 24px 26px;text-align:center}'
   +'.hx-pill{display:inline-flex;align-items:center;gap:7px;background:var(--pink-deep);color:#fff;font-size:.66rem;letter-spacing:2px;text-transform:uppercase;padding:7px 16px;border-radius:100px;font-weight:600}'
   +'.hx-body h3{font-family:"Playfair Display",serif;font-weight:600;font-size:1.6rem;margin:12px 0 4px;line-height:1.15}'
   +'.hx-sub{color:var(--ink-soft);font-size:.92rem;margin-bottom:14px}'
   +'.hx-incl{display:grid;gap:7px;text-align:left;background:#fff;border:1px solid var(--line);border-radius:16px;padding:14px 16px;margin-bottom:16px}'
   +'.hx-incl div{font-size:.88rem;display:flex;gap:9px;align-items:flex-start}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);

  function bloque(){
    if(document.getElementById('hxSealed'))return;
    var sec=document.getElementById('s-resultado');if(!sec)return;
    var gift=sec.querySelector('.gift-box');if(gift)gift.style.display='none';
    /* El nombre y el pilar se leen de la pantalla: la app los guarda
       en un ambito al que este script no alcanza. */
    var n='';
    try{ var _i=document.getElementById('nombre'); if(_i) n=(_i.value||'').trim(); }catch(e){}
    if(!n){ try{ var _g=document.getElementById('giftName');
      if(_g){ var _m=(_g.textContent||'').match(/^\s*([^,]+),/); if(_m) n=_m[1].trim(); } }catch(e){} }
    var eje='';
    try{ var _h=document.querySelector('#ejecard h2'); if(_h) eje=(_h.textContent||'').trim(); }catch(e){}
    var obj=''; try{ obj=problemasLabel()||''; }catch(e){}
    var msg='Hola, soy '+n+'. Acabo de hacer mi diagnóstico Hannitox.'
      +(eje?(' Mi pilar principal es '+eje+'.'):'')
      +(obj?(' Quiero trabajar '+obj+'.'):'')
      +' ¿Me ayudas con mi rutina?';
    try{ var _l=protocolLink(); if(_l) msg+='\n\n'+_l; }catch(e){}
    var num='3018593047'; try{ if(cfg&&cfg.waVentas) num=cfg.waVentas; }catch(e){}
    var wa='https://wa.me/57'+num+'?text='+encodeURIComponent(msg);
    var d=document.createElement('div');d.className='hx-sealed';d.id='hxSealed';
    d.innerHTML='<div class="hx-peek"><div class="hx-prow"><span class="hx-pdot"></span><span class="hx-pline"></span></div>'
     +'<div class="hx-prow"><span class="hx-pdot"></span><span class="hx-pline s"></span></div>'
     +'<div class="hx-prow"><span class="hx-pdot"></span><span class="hx-pline"></span></div></div><div class="hx-fade"></div>'
     +'<div class="hx-body"><span class="hx-pill">\ud83d\udd12 Falta tu protocolo</span>'
     +'<h3>'+(n?n+', tu ':'Tu ')+'<span class="fitalic">Hannitox</span><br>te esta esperando</h3>'
     +'<p class="hx-sub">Es la gu\u00eda nutricional de Sara, nutricionista y dermocosmiatra.<br><b>Va de regalo con tu rutina.</b></p>'
     +'<div class="hx-incl">'
     +'<div><span>\ud83e\uddf4</span><span>Tu <b>rutina facial</b> de d\u00eda y de noche, paso a paso y en video</span></div>'
     +'<div><span>\ud83c\udfc6</span><span>Tu <b>reto de 90 d\u00edas</b> para marcar h\u00e1bitos</span></div>'
     +'<div><span>\ud83e\udd57</span><span>C\u00f3mo organizar tu plato y tu <b>lista de mercado</b></span></div>'
     +'<div><span>\ud83d\udca7</span><span>Batido detox, tu agua del d\u00eda y desintoxicaci\u00f3n interna</span></div>'
     +'<div><span>\ud83d\udc9c</span><span>Acompa\u00f1amiento de tu asesora por WhatsApp</span></div>'
     +'</div>'
     +'<a class="btn wa" href="'+wa+'" target="_blank" rel="noopener">Hablar con mi asesora</a>'
     +'<div class="hint" style="margin-top:10px">Te contamos c\u00f3mo recibir tu Hannitox con tu rutina.</div></div>';
    sec.appendChild(d);
  }

  if(!abierto){
    document.body.classList.add('modo-clienta');
    if(typeof window.renderResult==='function'){
      var _r=window.renderResult;
      window.renderResult=function(){_r.apply(this,arguments);try{bloque();}catch(e){}};
    }
    try{if(document.getElementById('s-resultado')&&document.getElementById('s-resultado').classList.contains('active'))bloque();}catch(e){}
  }

  /* La llave del protocolo SOLO se pega si quien genera el link es una asesora.
     El link que arma la clienta sale limpio: solo abre su diagnostico.
     Ademas se limpia el ?a=... para que no viaje dentro del link. */
  if(typeof window.protocolLink==='function'){
    var _p=window.protocolLink;
    window.protocolLink=function(){
      var l=_p.apply(this,arguments);
      try{
        var h=l.indexOf('#');
        var base=(h>=0)?l.slice(0,h):l;
        var hash=(h>=0)?l.slice(h):'';
        var q=base.indexOf('?'); if(q>=0) base=base.slice(0,q);
        l=base+hash;
      }catch(e){}
      if(abierto && l.indexOf('#p=')>=0 && l.indexOf('&k=')<0) l+='&k='+KEY_P;
      return l;
    };
  }

  function botonCopiar(){
    if(!abierto)return;
    if(document.getElementById('hxCopy'))return;
    var sec=document.getElementById('s-protocolo');if(!sec)return;
    var d=document.createElement('div');d.id='hxCopy';
    d.style.cssText='margin:18px 0 0';
    d.innerHTML='<button class="btn wa" type="button">\ud83d\udce4 Copiar link para la clienta</button>'
      +'<div class="hint" style="text-align:center;margin-top:8px">P\u00e9galo en el chat: a ella se le abre su protocolo completo.</div>';
    d.firstChild.onclick=function(){
      var l='';try{ l=protocolLink(); }catch(e){}
      if(!l){alert('Abre primero el protocolo de una clienta.');return;}
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(l).then(function(){try{toast('Link copiado \u2713');}catch(e){}},function(){prompt('Copia el link:',l);});
      }else{prompt('Copia el link:',l);}
    };
    var tb=document.getElementById('tabbar');
    if(tb&&tb.parentNode===sec){sec.insertBefore(d,tb);}else{sec.appendChild(d);}
  }
  if(abierto){
    if(typeof window.buildProtocol==='function'){
      var _b=window.buildProtocol;
      window.buildProtocol=function(){_b.apply(this,arguments);try{botonCopiar();}catch(e){}};
    }
  }

  function alProtocolo(){
    try{
      if(!/[#&]p=/.test(location.hash||''))return;
      if(!abierto){if(typeof go==='function')go('resultado');return;}
      if(typeof buildProtocol!=='function'||typeof go!=='function')return;
      buildProtocol();go('protocolo');
    }catch(e){}
  }
  alProtocolo();setTimeout(alProtocolo,300);
})();
